/* eslint-disable no-sequences */
/* eslint-disable array-callback-return */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import "./styles.scss";
import Cards from "../../services/CardsService";
import Spinner from "react-spinner-material";

import DeleteIcon from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import Done from "@material-ui/icons/Done";

const columns = [
  {
    id: "titulo",
    label: "Título",
    minWidth: 200,
  },
  {
    id: "mensagem",
    label: "Mensagem",
    minWidth: 100,
  },
  {
    id: "cnae",
    label: "CNAE",
    minWidth: 120,
    align: "right",
  },
  {
    id: "tituloBotao",
    label: "Título do botão",
    minWidth: 120,
    align: "right",
  },
  {
    id: "situacao",
    label: "Situacao",
    minWidth: 120,
    align: "center",
    // format: value => value.toLocaleString(),
  },
  {
    id: "acoes",
    label: "",
    minWidth: 120,
    align: "right",
  },
];

function createData(titulo, mensagem, cnae, tituloBotao, situacao, acoes) {
  return { titulo, mensagem, cnae, tituloBotao, situacao, acoes };
}
const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  tableWrapper: {
    overflow: "auto",
  },
  acoes: {
    background: "red",
    fontSize: 80,
  },
});

export default function TableContent(props) {
  const classes = useStyles();

  const [rows, setRows] = React.useState([]);
  // let rows = [];

  // useEffect(() => { }, [contentProps])

  async function removeItem(item, key) {
    let temp = rows;
    temp[key] = await createData(
      item.titulo,
      item.mensagem,
      item.codCnae,
      item.tituloBotao,
      item.situacao,
      <div className={"excluindo"}>
        <div>Excluindo</div>
        <Spinner
          size={20}
          spinnerColor={"#0061c6"}
          spinnerWidth={4}
          visible={true}
        />
      </div>
    );

    setRows([...rows, temp]);

    const res = await Cards.deletarCard(item.id);
    if (res.status === 200) {
      let remove = rows;
      remove[key] = createData(
        `${item.titulo} (Removido)`,
        `${item.mensagem} (Removido)`,
        "",
        "",
        "",
        ""
      );
      setRows([...rows, remove]);
    } else {
      let errorRemove = rows;
      errorRemove[key] = createData(
        item.titulo,
        item.mensagem,
        item.codCnae,
        item.tituloBotao,
        item.situacao,
        <div className={"erroRemove"}>
          <div>Erro ao remover item</div>
          {acoes(item, key)}
        </div>
      );
      setRows([...rows, errorRemove]);
      // setTimeout(() => {
      //     let retunrError = rows;
      //     retunrError[key] = createData(
      //         item.titulo,
      //         item.mensagem,
      //         item.estado,
      //         item.dataNotificacao.split(' ')[0],
      //         item.usuarioResponsavel.nome,
      //         acoes(item, key)
      //     );
      //     setRows([...rows, retunrError]);
      // }, 3000);
    }
  }

  async function aprovarItem(item, key) {
    let temp = rows;
    temp[key] = await createData(
      item.titulo,
      item.mensagem,
      item.codCnae,
      item.tituloBotao,
      item.situacao,
      <div className={"excluindo"}>
        <div>Aprovando</div>
        <Spinner
          size={20}
          spinnerColor={"#0061c6"}
          spinnerWidth={4}
          visible={true}
        />
      </div>
    );

    setRows([...rows, temp]);

    const res = await Cards.aprovar(item.id, item.visualizacao);
    if (res.status === 200) {
      let remove = rows;
      item.situacao = "APROVADO";
      remove[key] = createData(
        `${item.titulo} (Aprovado)`,
        `${item.mensagem} (Aprovado)`,
        item.codCnae,
        item.tituloBotao,
        item.situacao,
        acoes(item, key)
      );
      setRows([...rows, remove]);
    } else {
      let errorRemove = rows;
      errorRemove[key] = createData(
        item.titulo,
        item.mensagem,
        item.codCnae,
        item.tituloBotao,
        item.situacao,
        <div className={"erroRemove"}>
          <div>Erro ao aprovar item</div>
          {acoes(item, key)}
        </div>
      );
      setRows([...rows, errorRemove]);
      // setTimeout(() => {
      //     let retunrError = rows;
      //     retunrError[key] = createData(
      //         item.titulo,
      //         item.mensagem,
      //         item.estado,
      //         item.dataNotificacao.split(' ')[0],
      //         item.usuarioResponsavel.nome,
      //         acoes(item, key)
      //     );
      //     setRows([...rows, retunrError]);
      // }, 3000);
    }
  }

  function changeItem(item, key) {
    // dispatch({ type: 'UPDATE_EDITCARD', editCard: { id: item.id, key: key } }))
    props.editItem(item, key);
  }

  function acoes(item, key) {
    const aprovado =
      item.situacao === "APROVADO" ? "acoes noSend" : "acoes send";
    const validaAprovar = item.situacao === "APROVADO" ? false : true;
    return (
      <div className={"btnAcoes"}>
        <div onClick={() => changeItem(item, key)}>
          <Edit className={"acoes"} color="primary" />
          <span>Editar</span>
        </div>
        {/* { (item.situacao === 'APROVADO') ? <div className="itemAprovado">Aprovado</div> : <Done className={'acoes send'} onClick={() => { aprovarItem(item, key) }} /> } */}
        <div
          onClick={() => {
            validaAprovar && aprovarItem(item, key);
          }}
        >
          <Done className={aprovado} />
          <span>Aprovar</span>
        </div>
        <div
          onClick={() => {
            removeItem(item, key);
          }}
        >
          <DeleteIcon className={"acoes"} color="error" />
          <span>Remover</span>
        </div>
      </div>
    );
  }

  if (!rows.length) {
    let incrementTable = [];
    props.content.data.map(
      (item, key) => (
        (incrementTable = createData(
          item.titulo,
          item.mensagem,
          item.codCnae,
          item.tituloBotao,
          item.situacao,
          acoes(item, key)
        )),
        rows.push(incrementTable)
      )
    );
  }

  return (
    <Paper className={classes.root}>
      <div className={classes.tableWrapper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, key) => (
              <TableRow hover role="checkbox" tabIndex={-1} key={key}>
                {columns.map((column) => (
                  <TableCell key={column.id} align={column.align}>
                    {column.format && typeof row[column.id] === "number"
                      ? column.format(row[column.id])
                      : row[column.id]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
            {!rows.length && (
              <TableRow>
                <TableCell>Nenhum push cadastrado!</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
      {/* <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{
                    'aria-label': 'previous page',
                }}
                nextIconButtonProps={{
                    'aria-label': 'next page',
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            /> */}
    </Paper>
  );
}
